import {makeActionCreator} from '../../redux-toolbelt';

export const setCurrentModal = makeActionCreator('setCurrentModal', (name, args) => (name ? {name, args} : null));
export const setCurrentModalArgs = makeActionCreator<'setCurrentModalArgs', Record<string, any> | null>('setCurrentModalArgs');
